import { SubPageName } from 'enums/buffet'
import {
  LineItemServiceEnum,
  LineItemServiceTypeForBuffetEnum,
  LineItemServiceTypeForDineInEnum,
  ProductAvailableServiceEnum,
  ProductServiceEnum,
} from 'graphQL/dinein/generate/operations'

export const generateBuffetProductDetailsUrl = ({
  categoryID,
  productID,
  serviceType,
}: {
  categoryID: number
  productID: number
  serviceType: LineItemServiceEnum | LineItemServiceTypeForDineInEnum | LineItemServiceTypeForBuffetEnum | undefined
}) => {
  const productDetailPath = `${SubPageName.ProductDetail}/${categoryID}/${productID}`
  const queryParams =
    serviceType === LineItemServiceEnum.BuffetALaCarteTakeaway
      ? `?product_service_type=${LineItemServiceEnum.BuffetALaCarteTakeaway}`
      : ''
  return `${productDetailPath}${queryParams}`
}

export const getAvailableService = ({
  productID,
  products,
  orderPackageID,
}: {
  productID: number
  products: {
    id: number
    buffetPackageProducts: { buffetPackageID: number }[]
    availableServices: ProductServiceEnum[]
  }[]
  orderPackageID
}) => {
  const findProduct = products.find((product) => product.id === productID)

  if (!findProduct) {
    return ProductAvailableServiceEnum.Buffet
  }

  const includePackage = findProduct.buffetPackageProducts.some(
    (buffetPackage) => buffetPackage.buffetPackageID === orderPackageID
  )
  if (includePackage) {
    return ProductAvailableServiceEnum.Buffet
  } else if (findProduct.availableServices.includes(ProductServiceEnum.BuffetALaCarte)) {
    return ProductAvailableServiceEnum.BuffetALaCarte
  } else if (findProduct.availableServices.includes(ProductServiceEnum.BuffetALaCarteTakeaway)) {
    return ProductAvailableServiceEnum.BuffetALaCarteTakeaway
  }
  return ProductAvailableServiceEnum.Buffet
}
